<template>
    <main class="dashboard-view">
        <h1 class="display-m">Space Center</h1>
        <p>This is the Space Center view</p>
    </main>
</template>